module.exports = __webpack_public_path__ + "img/testroom.097e354c.png";